import { ItemTypeEnum } from '@share/common-types';
import { DEFAULT_SLIDES, PLACEHOLDER_IMAGE } from './constants';
import type { ImageCarouselSlide } from './types';

const SLIDE_ID_TO_ITEM_TYPE: Record<string, ItemTypeEnum> = {
  hotel: ItemTypeEnum.Hotel,
  condo: ItemTypeEnum.Condo,
  cruise: ItemTypeEnum.Cruise,
};

export const getDefaultCarouselSlides = (): ImageCarouselSlide[] => {
  return DEFAULT_SLIDES.map((s) => ({ ...s }));
};

export const getSlideImageSrc = (imageSrc: string): string => {
  return imageSrc && imageSrc.trim() !== '' ? imageSrc : PLACEHOLDER_IMAGE;
};

export const getItemTypeFromSlideId = (slideId: string): ItemTypeEnum | undefined =>
  SLIDE_ID_TO_ITEM_TYPE[slideId.toLowerCase()];
